import type { StoreActionApi } from 'react-sweet-state';
import type { State } from '../../types';

export const setSignature =
	(cannedResponseContent: string | null) =>
	async ({ getState, setState }: StoreActionApi<State>) => {
		const formattedContent = cannedResponseContent && JSON.parse(cannedResponseContent);
		setState({
			...getState(),
			signature: formattedContent || null,
		});
	};

export const resetSignature =
	() =>
	async ({ getState, setState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			signature: undefined,
		});
	};
